import React, { useMemo, useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ReactComponent as ComputerSelectTestSvg } from "assets/images/homepage/computer_select_test.svg";
import useApp from "hooks/useApp";
import useCatalogDetail from "hooks/useCatalogDetail";
import { IDiseaseType } from "types/diseaseType";

interface DiseaseTypeSelectDialogProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    width: 560,
  },
}));

export const DiseaseTypeSelectDialog: React.FC<
  DiseaseTypeSelectDialogProps
> = ({ open, onClose }) => {
  const [diseaseType, setDiseaseType] = useState("");

  const { getDiseaseTypes } = useApp();
  const {
    catalog,
    setCustomize,
    setDiseaseType: setDiseaseTypeInContext,
  } = useCatalogDetail();
  const classes = useStyles();

  const diseaseTypes = useMemo(
    () => getDiseaseTypes(catalog?.diseaseType),
    [catalog?.diseaseType, getDiseaseTypes]
  );

  const onStartCustomize = () => {
    setCustomize(true);
    setDiseaseTypeInContext(
      diseaseTypes.find((item: IDiseaseType) => item.id === Number(diseaseType))
    );
    onClose();
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      classes={{ paper: classes.container }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          rowGap={3}
        >
          <ComputerSelectTestSvg width={80} height={80} />
          <Typography variant="body1" component="p">
            Please choose a disease type to start customizing.
          </Typography>
          <TextField
            select
            label="Select Disease Type"
            required
            fullWidth
            value={diseaseType}
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
              setDiseaseType(evt.target.value)
            }
            variant="filled"
          >
            {diseaseTypes.map((diseaseType: IDiseaseType) => (
              <MenuItem key={diseaseType.id} value={diseaseType.id}>
                {diseaseType.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          justifyContent="center"
          columnGap={2}
          py={3}
          flex={1}
        >
          <Button
            onClick={onStartCustomize}
            size="large"
            disabled={!diseaseType}
          >
            Start Customizing
          </Button>
          <Button variant="outlined" size="large" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
